import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { WebAccessControlCustomPagesBaseDataProvider } from '../dataProvider/WebAccessControlCustomPagesBaseDataProvider';

export class WebAccessControlCustomPagesDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, WebAccessControlCustomPagesBaseDataProvider);
  }
}
